export default __webpack_public_path__ + "static/media/newsroom-banner.d6438108.png";